import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrentinpune() {



  const cardData = {


   keyword: "Kia Carens On Rent in Pune",

  headingDescription: "Trustline Travels offers premium Kia Carens on rent in Pune for corporate travel, family trips, airport transfers, outstation journeys, sightseeing tours, business meetings, and group transportation. Kia Carens is a perfect choice for passengers looking for a stylish, spacious, and comfortable 6-7 seater vehicle with premium interiors, smooth performance, and excellent luggage space. Whether you need Kia Carens for one day rental, multiple days, one-way travel, round trip, Pune to Mumbai transfer, airport pickup and drop, or outstation packages, our professional chauffeurs ensure a safe and comfortable journey. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, clean and well-maintained vehicles, flexible rental plans, and 24/7 customer support, Trustline Travels is your trusted choice for Kia Carens rental services in Pune. Kia Carens rental options are available in Pune for local and outstation travel requirements through various cab providers. :contentReference[oaicite:1]{index=1}",

  topPlaces: [
    {
      title: "Mumbai Airport",
      description: "Mumbai Airport is one of the busiest airports in India and a popular destination for Pune travelers. Kia Carens rental provides comfortable airport pickup and drop services for families, corporate groups, and passengers with luggage."
    },
    {
      title: "Bandra",
      description: "Bandra is a premium Mumbai destination known for corporate offices, shopping streets, restaurants, entertainment zones, and sea-facing locations. It is a popular outstation route from Pune for Kia Carens bookings."
    },
    {
      title: "Hinjewadi IT Park",
      description: "Hinjewadi IT Park is Pune's biggest technology hub, featuring multinational companies, software firms, and corporate campuses. Kia Carens is suitable for executive travel and employee transportation."
    },
    {
      title: "Kharadi",
      description: "Kharadi is a major IT and commercial hub in Pune, home to EON IT Park, business offices, hotels, and corporate centers. It is a preferred destination for professionals requiring comfortable cab services."
    },
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is a major industrial and commercial region known for automobile industries, manufacturing companies, engineering businesses, and corporate offices."
    },
    {
      title: "Navi Mumbai",
      description: "Navi Mumbai is a growing commercial destination with corporate offices, industrial areas, business parks, and modern infrastructure. It is a popular outstation destination from Pune."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and lush green valleys. Kia Carens rental is ideal for comfortable family and group trips."
    },
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is a famous hill station near Pune known for strawberry farms, scenic viewpoints, lakes, waterfalls, and pleasant weather. It is a perfect destination for weekend vacations."
    },
    {
      title: "Alibaug",
      description: "Alibaug is a coastal getaway near Mumbai featuring beautiful beaches, forts, and peaceful surroundings. It is a popular destination for family trips and group travel from Pune."
    },
    {
      title: "Goa",
      description: "Goa is a famous holiday destination known for beaches, nightlife, churches, adventure activities, and scenic locations. Kia Carens rental from Pune to Goa is suitable for comfortable long-distance travel."
    }
  ],






"services": [
  {
    "name": "Kia Carens Car Rental Service in Pimpri Chinchwad",
    "description": "Book Kia Carens Car Rental Service in Pimpri Chinchwad for family trips, corporate travel, airport transfers, and outstation journeys with premium comfort, spacious seating, professional drivers, and affordable rental packages."
  },
  {
    "name": "Kia Carens on Rent in Pune for Outstation",
    "description": "Hire Kia Carens on Rent in Pune for Outstation travel with luxury interiors, AC comfort, experienced chauffeurs, flexible rental options, and smooth highway journeys."
  },
  {
    "name": "Kia Carens on Hire for Corporate Events",
    "description": "Choose Kia Carens on Hire for Corporate Events with premium seating, professional drivers, comfortable transportation, and reliable service for business requirements."
  },
  {
    "name": "Pune to Mahabaleshwar Kia Carens on Rent",
    "description": "Book Pune to Mahabaleshwar Kia Carens on Rent for comfortable hill station travel with spacious seating, experienced drivers, and safe long-distance transportation."
  },
  {
    "name": "Pune to Shirdi Kia Carens on Rent",
    "description": "Travel Pune to Shirdi with Kia Carens on Rent offering premium comfort, affordable fares, professional chauffeurs, and reliable pilgrimage travel services."
  },
  {
    "name": "Pune to Outstation Kia Carens on Rent",
    "description": "Hire Pune to Outstation Kia Carens for family vacations, business trips, and long-distance travel with luxury features, fixed pricing, and experienced drivers."
  },
  {
    "name": "Cab Service in Pune Kia Carens on Rent",
    "description": "Book Cab Service in Pune with Kia Carens on Rent for comfortable local rides, airport transfers, corporate travel, and outstation journeys."
  },
  {
    "name": "Kia Carens on Rent in Pimpri Chinchwad",
    "description": "Reserve Kia Carens on Rent in Pimpri Chinchwad with premium vehicles, professional chauffeurs, affordable pricing, and flexible travel options."
  },
  {
    "name": "Kia Carens on Rent in Pune for Outstation",
    "description": "Choose Kia Carens on Rent in Pune for Outstation trips with spacious interiors, luxury comfort, experienced drivers, and reliable transportation."
  },
  {
    "name": "7 Seater Kia Carens on Rent in Pune",
    "description": "Hire 7 Seater Kia Carens on Rent in Pune for family travel, group journeys, airport pickup, and comfortable outstation trips."
  },
  {
    "name": "Pune Local Kia Carens on Rent",
    "description": "Book Pune Local Kia Carens on Rent for city travel, meetings, events, and personal transportation with premium comfort and professional service."
  },
  {
    "name": "Pune to Outstation Kia Carens Taxi Fare Per Km",
    "description": "Check Pune to Outstation Kia Carens Taxi Fare Per Km with transparent pricing, affordable packages, and flexible rental options."
  },
  {
    "name": "Kia Carens Car Rental Pune",
    "description": "Book Kia Carens Car Rental Pune for luxury travel with spacious seating, AC comfort, experienced chauffeurs, and reliable rental services."
  },
  {
    "name": "Kia Carens on Rent in Hinjewadi",
    "description": "Hire Kia Carens on Rent in Hinjewadi for corporate travel, IT park transportation, airport transfers, and outstation trips with professional drivers."
  },
  {
    "name": "Kia Carens on Rent in Kharadi Pune",
    "description": "Book Kia Carens on Rent in Kharadi Pune for business travel, family trips, airport rides, and comfortable chauffeur-driven transportation."
  },
  {
    "name": "Car Hire Agency in Viman Nagar Pune",
    "description": "Choose Car Hire Agency in Viman Nagar Pune for premium Kia Carens rentals, airport transfers, corporate travel, and outstation cab services."
  },
  {
    "name": "Kia Carens on Rent in Magarpatta City",
    "description": "Reserve Kia Carens on Rent in Magarpatta City for office travel, family journeys, events, and comfortable long-distance transportation."
  },
  {
    "name": "Velocity Cabs",
    "description": "Velocity Cabs provides Kia Carens rental services in Pune with professional chauffeurs, premium vehicles, airport pickup, and outstation travel solutions."
  },
  {
    "name": "Kia Carens on Rent in Pune",
    "description": "Book Kia Carens on Rent in Pune for premium travel with spacious seating, luxury interiors, experienced drivers, and flexible rental plans."
  },
  {
    "name": "Kia Carens Rental Pune",
    "description": "Choose Kia Carens Rental Pune for corporate trips, family vacations, airport transfers, and outstation journeys with reliable chauffeur service."
  },
  {
    "name": "Kia Carens Cab in Pune",
    "description": "Hire Kia Carens Cab in Pune for comfortable travel with premium features, clean vehicles, professional drivers, and affordable pricing."
  },
  {
    "name": "Kia Carens Car Hire Pune",
    "description": "Book Kia Carens Car Hire Pune for business travel, events, airport transfers, and personal trips with premium comfort."
  },
  {
    "name": "Kia Carens Taxi Service Pune",
    "description": "Choose Kia Carens Taxi Service Pune for safe and luxurious transportation with experienced chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Book Kia Carens Cab Pune",
    "description": "Book Kia Carens Cab Pune online with instant confirmation, premium vehicles, flexible pickup locations, and professional driver support."
  },
  {
    "name": "Kia Carens Cab Booking Pune",
    "description": "Complete Kia Carens Cab Booking Pune for airport transfers, local travel, corporate transportation, and outstation journeys."
  },
  {
    "name": "6 Seater Kia Carens Cab Pune",
    "description": "Reserve 6 Seater Kia Carens Cab Pune for comfortable family travel, business trips, and premium transportation requirements."
  },
  {
    "name": "7 Seater Kia Carens Rental Pune",
    "description": "Hire 7 Seater Kia Carens Rental Pune for group travel, vacations, airport transfers, and comfortable outstation journeys."
  },
  {
    "name": "Cheap Kia Carens on Rent Pune",
    "description": "Book Cheap Kia Carens on Rent Pune with affordable rates, premium comfort, professional drivers, and reliable cab services."
  },
  {
    "name": "Kia Carens Cab Service Pune",
    "description": "Choose Kia Carens Cab Service Pune for comfortable rides, corporate travel, airport pickup, and outstation transportation."
  },
  {
    "name": "Kia Carens Outstation Cab Pune",
    "description": "Book Kia Carens Outstation Cab Pune for long-distance travel with luxury seating, fixed fares, experienced chauffeurs, and safe journeys."
  },
  {
    "name": "Kia Carens Airport Pickup Pune",
    "description": "Reserve Kia Carens Airport Pickup Pune for timely airport transfers with premium comfort, luggage space, and professional drivers."
  },
  {
    "name": "Kia Carens with Driver Pune",
    "description": "Hire Kia Carens with Driver Pune for private travel, corporate trips, events, and outstation journeys with experienced chauffeurs."
  }
],

"tableData": [
  ["Kia Carens Car Rental Service in Pimpri Chinchwad", "Kia Carens on Rent in Pune for Outstation"],
  ["Kia Carens on Hire for Corporate Events", "Pune to Mahabaleshwar Kia Carens on Rent"],
  ["Pune to Shirdi Kia Carens on Rent", "Pune to Outstation Kia Carens on Rent"],
  ["Cab Service in Pune Kia Carens on Rent", "Kia Carens on Rent in Pimpri Chinchwad"],
  ["Kia Carens on Rent in Pune for Outstation", "7 Seater Kia Carens on Rent in Pune"],
  ["Pune Local Kia Carens on Rent", "Pune to Outstation Kia Carens Taxi Fare Per Km"],
  ["Kia Carens Car Rental Pune", "Kia Carens on Rent in Hinjewadi"],
  ["Kia Carens on Rent in Kharadi Pune", "Car Hire Agency in Viman Nagar Pune"],
  ["Kia Carens on Rent in Magarpatta City", "Velocity Cabs"],
  ["Kia Carens on Rent in Pune", "Kia Carens Rental Pune"],
  ["Kia Carens Cab in Pune", "Kia Carens Car Hire Pune"],
  ["Kia Carens Taxi Service Pune", "Book Kia Carens Cab Pune"],
  ["Kia Carens Cab Booking Pune", "6 Seater Kia Carens Cab Pune"],
  ["7 Seater Kia Carens Rental Pune", "Cheap Kia Carens on Rent Pune"],
  ["Kia Carens Cab Service Pune", "Kia Carens Outstation Cab Pune"],
  ["Kia Carens Airport Pickup Pune", "Kia Carens with Driver Pune"]
],





whychoose: [
  {
    WhyChooseheading: "Premium Kia Carens on Rent in Pune",
    WhyChoosedescription: "Trustline Travels offers Kia Carens rental services in Pune with spacious interiors, comfortable seating, and professional chauffeur-driven travel for local and outstation journeys."
  },
  {
    WhyChooseheading: "Spacious 7 Seater Car for Comfortable Travel",
    WhyChoosedescription: "Kia Carens provides premium comfort with flexible seating, ample legroom, and luggage space, making it perfect for families, corporate groups, and long-distance trips."
  },
  {
    WhyChooseheading: "Pickup Available Across Pune",
    WhyChoosedescription: "Get convenient Kia Carens pickup from Pune Airport, railway station, Hinjewadi, Wakad, Baner, Kharadi, Viman Nagar, Pimpri Chinchwad, and other locations."
  },
  {
    WhyChooseheading: "Professional Chauffeur Service",
    WhyChoosedescription: "Our experienced drivers ensure safe, smooth, and timely travel with excellent knowledge of Pune city routes and outstation destinations."
  },
  {
    WhyChooseheading: "Flexible Rental Packages",
    WhyChoosedescription: "Book Kia Carens for hourly rentals, daily packages, airport transfers, corporate travel, one-way trips, and outstation journeys."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Kia Carens",
    WhyChoosedescription: "All vehicles are regularly serviced and maintained to provide a hygienic, comfortable, and premium travel experience."
  },
  {
    WhyChooseheading: "Ideal for Corporate & Family Trips",
    WhyChoosedescription: "Kia Carens rental is suitable for business meetings, family vacations, airport transfers, sightseeing, and comfortable group travel."
  },
  {
    WhyChooseheading: "24/7 Kia Carens Booking Support",
    WhyChoosedescription: "Reserve Kia Carens on rent anytime in Pune with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Kia Carens on Rent in Pune?",
    answer: "Yes, Trustline Travels offers Kia Carens rental services in Pune for local travel, outstation trips, airport transfers, and corporate requirements."
  },
  {
    question: "Can I hire Kia Carens with a driver in Pune?",
    answer: "Yes, chauffeur-driven Kia Carens rental services are available for comfortable and safe travel."
  },
  {
    question: "How many passengers can travel in Kia Carens?",
    answer: "Kia Carens is a spacious vehicle suitable for families and groups with comfortable seating and luggage space."
  },
  {
    question: "Where can I get Kia Carens pickup in Pune?",
    answer: "Pickup is available from Pune Airport, railway station, hotels, offices, residential areas, and major locations across Pune."
  },
  {
    question: "Can I book Kia Carens for outstation trips from Pune?",
    answer: "Yes, Kia Carens is available for destinations like Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, and other outstation locations."
  },
  {
    question: "Is Kia Carens available for airport transfers?",
    answer: "Yes, Kia Carens rental services are available for Pune Airport pickup, drop, and corporate airport transfers."
  },
  {
    question: "What rental options are available for Kia Carens?",
    answer: "You can hire Kia Carens on hourly, daily, one-way, round-trip, and customized rental packages."
  },
  {
    question: "Are toll and parking charges included in the rental fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed quotation."
  },
  {
    question: "Can I book Kia Carens for corporate events in Pune?",
    answer: "Yes, Kia Carens is suitable for corporate events, client transportation, business meetings, and executive travel."
  },
  {
    question: "How can I book Kia Carens On Rent in Pune with Trustline Travels?",
    answer: "Share your pickup location, destination, travel date, duration, passenger details, and requirements to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback: "We hired Kia Carens on rent in Pune for a family trip and had an excellent experience. The car was spacious, clean, and the driver provided professional service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Riya Sharma",
    feedback: "Trustline Travels provided a premium Kia Carens with a polite chauffeur. The booking was simple, and the entire journey was comfortable and well-managed.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens On Rent in Pune",
  "image": "https://www.trustlinetravels.com/assets/images/kia-carens-on-rent-in-pune.webp",
  "description":
    "Book Kia Carens On Rent in Pune with Trustline Travels for comfortable, spacious, and affordable 7-seater taxi services. We provide Kia Carens for local travel, outstation trips, airport transfers, corporate travel, and one-way or round-trip journeys from Pune with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/kia-carens-on-rent-in-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Kia Carens On Rent in Pune | 7 Seater Cab | +91 8087080034</title>

  <meta
    name="description"
    content="Book Kia Carens On Rent in Pune with Trustline Travels for affordable 7-seater taxi services. Hire Kia Carens for local travel, outstation trips, airport transfers, corporate travel, Mahabaleshwar, Shirdi, Hinjewadi, Pimpri Chinchwad, and all Pune locations with 24x7 availability."
  />

  <meta
    name="keywords"
    content="kia carens car rental service in pimpri chinchwad, kia carens on rent in pune for outstation, kia carens on hire for corporate events, pune to mahabaleshwar kia carens on rent in pune, Pune to Shirdi Kia Carens on Rent, Pune to Outstation Kia Carens on Rent, Cab Service in Pune Kia Carens on Rent, kia carens on rent in pimpri chinchwad, 7 seater kia carens on rent in pune, pune local kia carens on rent, pune to outstation kia carens taxi fare per km, Kia Carens Car Rental Pune, kia carens on rent in hinjewadi, Kia Carens on Rent in Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarenceonrentinpune;